import Stack from "@mui/material/Stack";
import { GoMakeAutoComplate } from "@/components";
import { useTranslation } from "react-i18next";
import { SecondaryButton } from "@/components/button/secondary-button";
import { useStyle } from "./style";
import { PrimaryTable } from "@/components/tables/primary-table";
import { GoMakeDatepicker } from "@/components/date-picker/date-picker-component";
import { useEmployeeList } from "@/hooks/use-employee-list";

interface IQuoteLogsProps {
  employeeId: any;
  handleSelectEmployee: (e: React.ChangeEvent<{}>, value: any) => void;
  onClickClearLogsFilter?: () => void;
  onClickSearchLogsFilter?: () => void;
  onSelectDateRange: (fromData: Date, toDate: Date) => void;
  resetLogsDatePicker: boolean;
  logsTableHeaders: string[];
  logsTableRows: any;
}
const DocumentLogsWidget = ({
  logsTableHeaders,
  employeeId,
  handleSelectEmployee,
  resetLogsDatePicker,
  onSelectDateRange,
  onClickSearchLogsFilter,
  onClickClearLogsFilter,
  logsTableRows,
}: IQuoteLogsProps) => {
  const { t } = useTranslation();
  const { classes } = useStyle();
  const { employeesCategories } = useEmployeeList();

  return (
    <Stack direction={"column"} gap={"20px"} paddingTop={"10px"}>
      <Stack direction={"row"} gap={"8px"} alignItems={"baseline"}>
        <GoMakeAutoComplate
          key={employeeId?.id}
          options={employeesCategories}
          style={classes.dropDownListStyle}
          getOptionLabel={(option: any) => option.label}
          placeholder={t("sales.quote.selectEmployee")}
          onChange={(e: any, value: any) => handleSelectEmployee(e, value)}
          value={employeeId}
        />
        <GoMakeDatepicker
          onChange={onSelectDateRange}
          placeholder={t("boardMissions.chooseDate")}
          reset={resetLogsDatePicker}
          style={{ width: "50%" }}
        />
        <SecondaryButton
          themeAsPrimary
          variant="outlined"
          themeVariant="text"
          onClick={onClickClearLogsFilter}
          style={{
            width: "fit-content",
            height: "var(--theme-button-height, 35px)",
          }}
        >
          {t("sales.quote.clear")}
        </SecondaryButton>
        <SecondaryButton
          themeAsPrimary
          variant="contained"
          onClick={onClickSearchLogsFilter}
          style={{
            height: "var(--theme-button-height, 35px)",
            width: "fit-content",
          }}
        >
          {t("sales.quote.search")}
        </SecondaryButton>
      </Stack>
      <PrimaryTable
        stickyFirstCol={false}
        stickyHeader={true}
        maxHeight={400}
        rows={logsTableRows}
        headers={logsTableHeaders}
        columnWidths={["20%", "20%", "40%", "20%"]}
      />
    </Stack>
  );
};
export { DocumentLogsWidget };
